import React from 'react';

import Seo from '../components/seo/head';

import Hero from '../components/hero';

const Cascade = ({ data, pageContext }) => {

  return (
    <div
        className="page-wrapper"
    >
        <Hero
            title="Stratton mk3 system selector"
            backgroundColor = '#0054a0'
            textColour = '#fff'
            headerStyle="Shorter"
            paragraph={"Need a compact solution that doesn't compromise on power? Look no further."}
        />
        <div
            className={`content content-middle`}
        >
            <p>The Stratton mk3 is a wall hung condensing boiler offering a small and durable solution suitable for even the tightest plant rooms. When installed with a plate heat exchanger or low loss header, the Stratton mk3 can be fitted to old systems with peace of mind that the new boiler is protected from dirt and debris in an existing secondary circuit.</p>
            <h2>What is the system selector?</h2>
            <p>The Stratton System Selector guides you through the product requirements needed for a cascade set up. Boiler cascades consist of multiple boilers linked together. They ensure flexibility as each boiler can adjust its operating capacity in line with demand. Available with a range of plate heat exchangers and low loss headers, the system selector can help ensure you have everything you need for an efficient heating system.</p>
            <p>If your proposed system moves away from cascade operating conditions or you would prefer to speak with a member of the team, please get in touch with your local <a href="/contact-sales-managers">Area Sales Manager</a> or <a href="/site-survey">request a site survey</a>.</p>
            <h3>Let's get started</h3>
            <p>Simply answer a few questions about your project and all of the possible items needed will be listed on screen for selection. Your suggested products will be emailed to you so you can share with your <a href="/contact-sales-managers">Area Sales Manager</a> for further discussion and a quote.</p>
        </div>
        <iframe
            className="iframe-wrapper"
            title="Stratton System Selector"
            referrerPolicy="unsafe-url"
            src="https://hamworthy.groupe-atlantic.fr/form-hamworthy/"
        ></iframe>
    </div>
  )
}

export const Head = ({data, location}) => {

    return(
        <Seo
            location={location}
            metaTitle="Stratton mk3 system selector"
            metaDescription="The Stratton mk3 system selector for installations that require a cascade of boilers frame and header kit and hydraulic seperation"
            robotsMetaTag="index, follow"
        />
    )
}

export default Cascade;